import Primes1 from '../../../Media/BSD/Terravia/Teravia Adora Prime.webp'
import Primes2 from '../../../Media/BSD/Terravia/Teravia Adora Prime.webp'





const Primesimages =[
Primes1,Primes2
]

export default Primesimages;